import React, { useCallback, useEffect, useState } from 'react';
import API from '../../api';

// redux
import { mapDispatchProps, mapStateToProps } from '../../store/store';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Modal } from 'antd';
import { Tooltip } from 'react-tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { HelpCircle, X } from 'react-feather';

// swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import Swal from 'sweetalert2';

import { Menu, Separator, useContextMenu } from 'react-contexify';

import SeedingWithCommissionsPanel from 'pages/notification-panel/SeedingWithCommissionsPanel';
import { TYPES as SEEDING_WITH_COMMISSION_TYPE } from 'pages/campaigns/alert/seedingWithCommissionsAlert';
import CreateProductMasterModal, {
  RENTAL_TYPE,
} from '../../components/createProductMasterModal/createProductMasterModal';
import AdditionalProductsRecommendation from '../../pages/products/additionalProductsRecommendation';

import 'react-contexify/dist/ReactContexify.css';
import TextInputField from '../../components/textInput';
import Button from '../../components/button';
import Checkbox from '../../components/checkbox';
import Divider from '../../components/divider';
import LoadingText from 'components/loadingText';
import ModalRentalDiscontinued from 'components/modalRentalDiscontinued';
import Paginator from '../../components/paginator';
import Select from '../../components/select';
import { ROUTES } from '../../routes';
import { useLanguage } from '@languages/index';
import PRODUCT from 'constants/product';
import USER from '../../constants/user';

import { isGlovv } from 'constants/domains/domains';

function useForceUpdate() {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}

const ProductsIndex = (props: any) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.database.product,
    ...language.pages.products,
    ...language.component.seedingWithCommissionsAlert,
  };
  const productStatusFl_title_map = {
    1: languageTexts.status_fl_1,
    2: languageTexts.status_fl_2,
    3: languageTexts.status_fl_3,
    4: languageTexts.status_fl_4,
    5: languageTexts.status_fl_5,
    6: languageTexts.status_fl_6,
    7: languageTexts.status_fl_7,
    8: languageTexts.status_fl_8,
    9: languageTexts.status_fl_9,
  };

  const navigate = useNavigate();
  const forceUpdate = useForceUpdate();

  const [currentlyInRentModalVisible, setCurrentlyInRentModalVisible] = useState(false);
  const [currentlyInRentUsers, setCurrentlyInRentUsers] = useState([]);

  const PRODUCT_MENU_ID = 'product-menu';

  const { show } = useContextMenu({
    id: PRODUCT_MENU_ID,
  });

  function displayMenu(e) {
    show(e, {
      position: { x: Math.max(0, e.clientX - 335), y: Math.max(0, e.clientY) },
    });
  }

  const [search, setSearch] = useState('');

  const searchOptions = [
    { name: languageTexts.index_search_option_1, value: 0 },
    { name: languageTexts.status_fl_1, value: 1 },
    { name: languageTexts.status_fl_2, value: 2 },
    { name: languageTexts.status_fl_3, value: 3 },
    { name: languageTexts.status_fl_4, value: 4 },
    { name: languageTexts.status_fl_5, value: 5 },
    { name: languageTexts.status_fl_6, value: 6 },
    { name: languageTexts.status_fl_7, value: 7 },
    { name: languageTexts.status_fl_8, value: 8 },
  ];

  const [selectedSearchOption, setSelectedSearchOption] = useState(searchOptions[0]);

  const [brand, setBrand] = useState(null);
  const [brandLogoUrl, setBrandLogoUrl] = useState();
  const [brandAtTag, setBrandAtTag] = useState('');
  const [brandHashTags, setBrandHashTags] = useState('');
  const [brandEmail, setBrandEmail] = useState('');

  const [fetchedProductMasters, setFetchedProductMasters] = useState<any>([]);
  const [productCnt, setProductCnt] = useState(0);
  const [regProductCnt, setRegProductCnt] = useState(0);
  const [rentIngProductCnt, setRentIngProductCnt] = useState(0);

  const [isFetchFinished, setIsFetchFinished] = useState(false);
  const [isContentEnded, setIsContentEnded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginator, setPaginator] = useState<any>(undefined);

  const [isFetching, setIsFetching] = useState<any>(false);

  const [selectedProduct, setSelectedProduct] = useState<any>(); // deprecated?

  const [selectedRegProductMasters, setSelectedRegProductMasters] = useState<any>([]);
  const [selectedRentIngProductMasters, setSelectedRentIngProductMasters] = useState<any>([]);

  /** Admin-request <Menu /> contexts **/
  const [menuRegProductMasters, setMenuRegProductMasters] = useState<any>([]);
  const [menuRentIngProductMasters, setMenuRentIngProductMasters] = useState<any>([]);
  const [menuSelectedRegProducts, setMenuSelectedRegProducts] = useState<any>([]);
  const [menuSelectedRentIngProducts, setMenuSelectedRentIngProducts] = useState<any>([]);

  const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);
  const [isCommissionsPanelVisible, setIsCommissionsPanelVisible] = useState(0);

  useEffect(() => {
    fetchBrand();
    fetchProductMasters();
  }, []);

  const fetchBrand = () => {
    API.Brand.show({ brandToken: props.auth.token })
      .then((response) => {
        setBrand(response.data.brand);
        if (!brandLogoUrl) {
          setBrandLogoUrl(response.data.brand.imageUrl);
        }
        if (!brandAtTag) {
          setBrandAtTag(response.data.brand.atTag);
        }
        if (!brandHashTags) {
          setBrandHashTags(response.data.brand.hashTags);
        }
        if (!brandEmail) {
          setBrandEmail(response.data.brand.email);
        }
      })
      .catch((error) => {
        props.showModal({ text: languageTexts.index_text_1 });
      });
  };

  const fetchProductMasters = (config?: any) => {
    if (isContentEnded && config?.refresh == false) {
      return false;
    }

    setIsFetching(true);
    // init states
    setFetchedProductMasters([]);
    setSelectedRegProductMasters([]);
    setSelectedRentIngProductMasters([]);
    setMenuRegProductMasters([]);
    setMenuRentIngProductMasters([]);
    setMenuSelectedRegProducts([]);
    setMenuSelectedRentIngProducts([]);

    let targetPage = config?.page ? config.page : currentPage;

    if (config?.refresh) {
      targetPage = 1;
    }

    API.Product.index({
      ...{
        brandToken: props.auth.token,
        page: targetPage,
        statusFl: selectedSearchOption.value,
        productName: search,
      },
    })
      .then((response) => {
        const products = response.data.products;
        const _paginator = response.data.paginator;

        const [regProductCnt, rentIngProductCnt] = calculateProductCnts(products);

        setFetchedProductMasters(products);
        setProductCnt(response.data.count);
        setRegProductCnt(regProductCnt);
        setRentIngProductCnt(rentIngProductCnt);
        setCurrentPage(targetPage);
        setIsFetchFinished(true);
        setIsContentEnded(_paginator.currentPage >= _paginator.lastPage);
        setIsFetching(false);
        setPaginator(_paginator);
      })
      .catch((error) => {
        props.showModal({ text: error.message });
      })
      .finally(() => {
        forceUpdate();
      });
  };

  const requestProductRegister = async (products) => {
    if (products.length == 0) {
      return;
    }

    try {
      const response = await API.Product.register({
        id: products[0].productMasterId,
        products: products.map((p) => ({
          id: p.id,
          brandId: p.brandId,
          statusFl: p.statusFl,
        })),
        brandToken: props.auth.token,
      });
      props.showModal({
        text: response.data.message,
      });

      fetchProductMasters({ refresh: true });
    } catch (error) {
      props.showModal({
        text: error.message,
      });
    }
  };

  const requestProductsReturn = async (products) => {
    try {
      const response = await API.Product.return({
        id: products[0].productMasterId,
        products: products.map((p) => ({
          id: p.id,
          brandId: p.brandId,
          statusFl: p.statusFl,
        })),
        brandToken: props.auth.token,
      });
      props.showModal({
        text: response.data.message,
      });
      fetchProductMasters({ refresh: true });
    } catch (error) {
      props.showModal({
        text: error.message,
      });
    }
  };

  const calculateProductCnts = (productMasters) => {
    let regProductCnt = 0;
    let rentIngProductCnt = 0;

    for (let i = 0; i < productMasters.length; i++) {
      const productMaster = productMasters[i];
      let hasRegProduct = false;
      let hasRentingProduct = false;
      for (let j = 0; j < productMaster.products.length; j++) {
        if (hasRegProduct && hasRentingProduct) {
          break;
        }
        const product = productMaster.products[j];
        if (product.statusFl == PRODUCT.STATUS_FL_CD.REG) {
          hasRegProduct = true;
        } else if (product.statusFl == PRODUCT.STATUS_FL_CD.RENT_ING) {
          hasRentingProduct = true;
        }
      }
      if (hasRegProduct) {
        regProductCnt++;
      }
      if (hasRentingProduct) {
        rentIngProductCnt++;
      }
    }
    return [regProductCnt, rentIngProductCnt];
  };

  const filterProductMastersAndProductsByStatusFl = (productMasters, statusFl) => {
    const id_productMaster_map = {};
    const filteredProducts = [];
    for (const pm of productMasters) {
      const products = pm.products;
      for (let i = 0; i < products.length; i++) {
        if (products[i].statusFl == statusFl) {
          id_productMaster_map[pm.id] = pm;
          filteredProducts.push(products[i]);
        }
      }
    }
    const filteredProductMasters = Object.values(id_productMaster_map);
    return [filteredProductMasters, filteredProducts];
  };

  const selectAllProductMastersAndProducts = (statusFl) => {
    const [newProductMasters, newProducts] = filterProductMastersAndProductsByStatusFl(fetchedProductMasters, statusFl);

    switch (statusFl) {
      case PRODUCT.STATUS_FL_CD.REG:
        setSelectedRentIngProductMasters([]);
        setSelectedRegProductMasters(newProductMasters);
        break;
      case PRODUCT.STATUS_FL_CD.RENT_ING:
        setSelectedRegProductMasters([]);
        setSelectedRentIngProductMasters(newProductMasters);
        break;
      default:
        break;
    }
  };

  const renderLoadingIndicator = () => {
    return isFetching && !isContentEnded ? (
      <div className="flex flex-row justify-center text-center my-5">
        <span className="prose prose-xl text-slate-400">{languageTexts.loading_1}</span>
      </div>
    ) : null;
  };

  const renderTooltipButton = (tooltipTagId, tooltip) => {
    return (
      <div>
        <img id={tooltipTagId} className={'w-[14px] h-[14px] ml-2'} src={`/assets/icons/ic-help-circle-black.svg`} />
        <Tooltip
          anchorSelect={'#' + tooltipTagId}
          className="max-w-[600px] text-[13px] py-1 whitespace-pre-wrap"
          place="top"
        >
          {tooltip}
        </Tooltip>
      </div>
    );
  };

  const renderStatusRow = (title, tooltip, tooltipTagId, count, count_suffix) => {
    return (
      <div className="flex flex-row justify-between">
        <div className="flex flex-row justify-items-start">
          <div>{title}</div>
          {!!tooltipTagId && !!tooltip ? renderTooltipButton(tooltipTagId, tooltip) : null}
        </div>
        <div className="flex flex-col gap-3 text-[#000000] font-bold">{`${count.toLocaleString()}${count_suffix}`}</div>
      </div>
    );
  };

  const renderProductsHeaderStatus = () => {
    const shadow = {
      border: '0.5px solid rgba(0, 0, 0, 0.1)',
      boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.12)',
    };

    const productsInRentableCount = brand?.productsInRentableCount ?? 0;
    const productsInInspectionCount = brand?.productsInInspectionCount ?? 0;
    const productsInReturningCount = brand?.productsInReturningCount ?? 0;
    const rentingModelCount = brand?.rentingModelCount ?? 0;
    const rentingAmbassadorCount = brand?.rentingAmbassadorCount ?? 0;

    return (
      <div style={shadow}>
        <div className="flex flex-col justify-items-start px-5 lg:px-8 xl:px-0 mx-auto md:w-[800px] xl:w-[1024px] my-8 gap-2">
          <div className="flex flex-row justify-between">
            <div className="text-4xl font-bold w-[100px] md:w-[150px] lg:w-[200px] tracking-tighter">
              {languageTexts.product}
            </div>
            <div className="flex flex-col items-end">
              <div className="flex flex-row ml-auto items-center">
                <span className="text-[15px]">{languageTexts.index_text_2}</span>

                <CopyToClipboard
                  onCopy={(copied, result) => {
                    let title = languageTexts.index_text_3;
                    let text = languageTexts.index_text_4;
                    if (!result) {
                      title = languageTexts.index_text_5;
                      text = languageTexts.index_text_6;
                    }

                    props.showModal({ title: title, text: text });
                  }}
                  text={languageTexts.index_text_7}
                >
                  <div className="ml-6 cursor-pointer select-none underline font-bold text-[#999999]">
                    {languageTexts.index_text_8}
                  </div>
                </CopyToClipboard>
              </div>
              <div
                onClick={(e) => {
                  setIsTermsModalVisible(true);
                }}
                className="mt-2 cursor-pointer select-non underline font-bold text-[#999999]"
              >
                {languageTexts.index_text_31}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4 text-[15px] mt-[13px]">
            {renderStatusRow(
              languageTexts.index_text_9,
              null,
              null,
              productsInRentableCount,
              languageTexts.index_text_10,
            )}
            {renderStatusRow(
              languageTexts.index_text_11,
              languageTexts.index_text_12,
              'helper-tooltip-rentable-cont',
              productsInInspectionCount,
              languageTexts.index_text_10,
            )}
            {renderStatusRow(
              languageTexts.index_text_13,
              languageTexts.index_text_14,
              'helper-tooltip-returning-count',
              productsInReturningCount,
              languageTexts.index_text_10,
            )}
            <Divider style={{ borderColor: 'black', opacity: 0.1 }} />
            {renderStatusRow(languageTexts.index_text_15, null, null, rentingModelCount, languageTexts.index_text_16)}
            {renderStatusRow(
              languageTexts.index_text_17,
              null,
              null,
              rentingAmbassadorCount,
              languageTexts.index_text_16,
            )}
            <Divider style={{ borderColor: 'black', opacity: 0.1 }} />
            <div
              className="flex flex-row ml-auto items-center cursor-pointer text-black gap-1"
              onClick={() => {
                showAdditionalProductsRecommendationModal();
              }}
            >
              <span className="underline font-bold text-[#000000]">{languageTexts.index_text_18}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderProductsHeaderInput = () => {
    return (
      <div
        className="mt-[30px] flex flex-col text-[14px]"
        //   style={{ backgroundColor: '#302c2b' }}
      >
        <div className="px-[20px] flex items-center">
          <div className="w-full flex text-white text-center">
            <div className="w-full flex" style={{ height: '38px' }}>
              <div className="w-[280px] text-black">
                <Select
                  className={'pl-[4px] w-full h-full flex border-black'}
                  bordered
                  margin={0}
                  options={searchOptions}
                  value={selectedSearchOption.name}
                  selected={selectedSearchOption}
                  onChange={(value) => {
                    const selected = searchOptions.filter((option) => option.name == value)[0];
                    setSelectedSearchOption(selected);
                  }}
                />
              </div>
              <div className="w-full">
                <TextInputField
                  height={'38px'}
                  margin={0}
                  inputContainerStyle={{
                    borderLeft: 'none',
                  }}
                  inputStyle={{
                    padding: '0 10px',
                    height: '100%',
                  }}
                  bordered
                  placeholder={languageTexts.index_text_44}
                  onChangeText={(value) => {
                    setSearch(value);
                  }}
                />
              </div>

              <div className="prose">
                <Button
                  className={'py-1 px-1 md:px-3'}
                  style={{ borderRadius: '0' }}
                  text={languageTexts.search}
                  //   buttonColor={'rgb(140,137,133)'}
                  buttonColor={'BLACK'}
                  //   borderColor={'rgb(140,137,133)'}
                  borderColor={'BLACK'}
                  textColor={'WHITE'}
                  textClassName={'prose text-sm'}
                  onClick={() => {
                    fetchProductMasters({ refresh: true });
                  }}
                />
              </div>

              <div className="prose text-white ml-[10px]">
                <Button
                  className={'w-[150px] py-1 px-3 text-center'}
                  style={{ borderRadius: '0' }}
                  text={languageTexts.index_text_19}
                  //   buttonColor={'rgb(255,188,100)'}
                  //   borderColor={'rgb(255,188,100)'}
                  buttonColor={'BLACK'}
                  borderColor={'BLACK'}
                  textColor={'WHITE'}
                  textClassName={'prose text-sm'}
                  onClick={() => {
                    props.showModal({
                      content: () => {
                        return (
                          <ModalRentalDiscontinued closeModal={props.closeModal} />
                        );
                      },
                    });
                    // showProductMasterDetailModal('CREATE');
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-[14px] px-[20px] flex gap-[30px]">
          <Checkbox
            className={'py-[6px] select-none'}
            textClassName={'select-none'}
            text={languageTexts._index_text_45(regProductCnt)}
            checked={regProductCnt > 0 && selectedRegProductMasters.length === regProductCnt}
            onClick={() => {
              if (regProductCnt === 0) return;

              // uncheck
              if (selectedRegProductMasters.length === regProductCnt) {
                setSelectedRegProductMasters([]);
                setMenuSelectedRegProducts([]);
                return;
              }
              // check
              selectAllProductMastersAndProducts(PRODUCT.STATUS_FL_CD.REG);
            }}
          />
          <Checkbox
            className={'py-[6px] select-none'}
            textClassName={'select-none'}
            text={languageTexts._index_text_46(rentIngProductCnt)}
            checked={rentIngProductCnt > 0 && selectedRentIngProductMasters.length === rentIngProductCnt}
            onClick={() => {
              if (rentIngProductCnt === 0) return;

              // uncheck
              if (selectedRentIngProductMasters.length === rentIngProductCnt) {
                setSelectedRentIngProductMasters([]);
                setMenuSelectedRentIngProducts([]);
                return;
              }
              // check
              selectAllProductMastersAndProducts(PRODUCT.STATUS_FL_CD.RENT_ING);
            }}
          />
        </div>
      </div>
    );
  };

  const showAdditionalProductsRecommendationModal = () => {
    props.showModal({
      isVisible: true,
      content: () => {
        return <AdditionalProductsRecommendation />;
      },
    });
  };

  const showProductMasterDetailModal = (method, master?) => {
    props.showModal({
      isVisible: true,
      preventCloseWithBackgroundDimmer: true,
      content: () => {
        // fetchProductMasters(true);
        return (
          <CreateProductMasterModal
            rentalType={RENTAL_TYPE.RENTAL}
            method={method}
            master={master}
            onConfirm={() => {
              fetchProductMasters({ refresh: true });
            }}
            onSuccess={() => {
              fetchProductMasters({ refresh: true });
            }}
          />
        );
      },
    });
  };

  const showCurrentlyInRentUserModal = (productId, users) => {
    setCurrentlyInRentModalVisible(productId);
    setCurrentlyInRentUsers(users);
  };

  const handleAdminRequestButtonClick = (e, master, hasRegProducts, hasRentIngProducts) => {
    function selectProductsOfThisProductMaster() {
      if (hasRegProducts) {
        setMenuRegProductMasters([master]);
        setMenuSelectedRegProducts([...master.products.filter((p) => p.statusFl === PRODUCT.STATUS_FL_CD.REG)]);
        setTimeout(() => {
          displayMenu(e);
        }, 300);
      } else if (hasRentIngProducts) {
        setMenuRentIngProductMasters([master]);
        setMenuSelectedRentIngProducts([
          ...master.products.filter((p) => p.statusFl === PRODUCT.STATUS_FL_CD.RENT_ING),
        ]);
        setTimeout(() => {
          displayMenu(e);
        }, 300);
      }
    }

    // init selected masters
    setSelectedRegProductMasters([]);
    setSelectedRentIngProductMasters([]);
    // init menu states
    setMenuRegProductMasters([]);
    setMenuRentIngProductMasters([]);
    setMenuSelectedRegProducts([]);
    setMenuSelectedRentIngProducts([]);

    if (hasRegProducts) {
      if (regProductCnt > 1) {
        props.showModal({
          hideCloseButton: true,
          title: languageTexts.index_text_60,
          text: languageTexts._index_text_61(regProductCnt - 1),
          confirmButtonText: languageTexts.yes,
          cancelButtonText: languageTexts.no,
          confirm: () => {
            const [productMasters, products] = filterProductMastersAndProductsByStatusFl(
              fetchedProductMasters,
              PRODUCT.STATUS_FL_CD.REG,
            );
            setMenuRegProductMasters(productMasters);
            setMenuSelectedRegProducts(products);
            setTimeout(() => {
              displayMenu(e);
            }, 300);
          },
          cancel: () => {
            selectProductsOfThisProductMaster();
          },
        });
      } else {
        selectProductsOfThisProductMaster();
      }
    } else if (hasRentIngProducts) {
      if (rentIngProductCnt > 1) {
        props.showModal({
          hideCloseButton: true,
          title: languageTexts.index_text_62,
          text: languageTexts._index_text_63(rentIngProductCnt - 1),
          confirmButtonText: languageTexts.yes,
          cancelButtonText: languageTexts.no,
          confirm: () => {
            const [productMasters, products] = filterProductMastersAndProductsByStatusFl(
              fetchedProductMasters,
              PRODUCT.STATUS_FL_CD.RENT_ING,
            );
            setMenuRentIngProductMasters(productMasters);
            setMenuSelectedRentIngProducts(products);
            setTimeout(() => {
              displayMenu(e);
            }, 300);
          },
          cancel: () => {
            selectProductsOfThisProductMaster();
          },
        });
      } else {
        selectProductsOfThisProductMaster();
      }
    }
  };

  const handleAdminRequestBulkButtonClick = (e) => {
    // init menu states
    setMenuRegProductMasters([]);
    setMenuRentIngProductMasters([]);
    setMenuSelectedRegProducts([]);
    setMenuSelectedRentIngProducts([]);

    if (selectedRegProductMasters.length > 0) {
      const [productMasters, products] = filterProductMastersAndProductsByStatusFl(
        selectedRegProductMasters,
        PRODUCT.STATUS_FL_CD.REG,
      );
      setSelectedRentIngProductMasters([]);
      setMenuRegProductMasters(productMasters);
      setMenuSelectedRegProducts(products);
      setTimeout(() => {
        displayMenu(e);
      }, 300);
    } else if (selectedRentIngProductMasters.length > 0) {
      const [productMasters, products] = filterProductMastersAndProductsByStatusFl(
        selectedRentIngProductMasters,
        PRODUCT.STATUS_FL_CD.RENT_ING,
      );
      setSelectedRegProductMasters([]);
      setMenuRentIngProductMasters(productMasters);
      setMenuSelectedRentIngProducts(products);
      setTimeout(() => {
        displayMenu(e);
      }, 300);
    }
  };

  const handleSubmenuClick = (event) => {
    event.stopPropagation();
  };

  const handleSelectAll = (event) => {
    event.stopPropagation();

    const copy: any = {
      ...selectedProduct,
    };
    let boolean = true;
    copy.products.forEach((product) => {
      if (product.checked) {
        boolean = false;
      }
    });
    copy.products.forEach((product) => {
      product.checked = boolean;
    });
    setSelectedProduct(copy);
  };

  const renderProductContextTab = (master, hasRegProducts, hasRentIngProducts) => {
    if (!hasRegProducts && !hasRentIngProducts) {
      return (
        <div className="col-admin_requests basis-2/12 text-center">
          <span>{'-'}</span>
        </div>
      );
    }

    const buttonText = hasRegProducts ? languageTexts.index_text_51 : languageTexts.index_text_52;
    const textColor = hasRegProducts ? '#FFFFFF' : '#000000';
    const buttonColor = hasRegProducts ? '#000000' : '#FFFFFF';
    const borderColor = hasRegProducts ? '#000000' : '#E8E8E8';

    return (
      <div className="col-admin_requests basis-2/12 flex flex-row justify-center text-center cursor-pointer">
        <Button
          className={'py-[6px] px-1 md:px-2'}
          style={{ borderRadius: '0' }}
          text={buttonText}
          buttonColor={buttonColor}
          borderColor={borderColor}
          textColor={textColor}
          textClassName={'prose text-[14px]'}
          onClick={(e) => {
            handleAdminRequestButtonClick(e, master, hasRegProducts, hasRentIngProducts);
          }}
        />
      </div>
    );
  };

  const renderRequestMenu = () => {
    console.log('mode', menuRegProductMasters.length, menuRentIngProductMasters.length);
    const mode = menuRegProductMasters.length > 0 ? 'REG' : menuRentIngProductMasters.length > 0 ? 'RENT_ING' : null;

    if (mode == null) {
      return null;
    }

    const productMasters = mode === 'REG' ? menuRegProductMasters : menuRentIngProductMasters;
    const selectedProducts = mode === 'REG' ? menuSelectedRegProducts : menuSelectedRentIngProducts;

    return (
      <Menu id={`${PRODUCT_MENU_ID}`} className="react-contexify react-contexify-custom" animation={false}>
        <div className="w-[335px]" onClick={handleSubmenuClick}>
          <div className="p-[20px] text-start text-[17px] font-bold">
            {mode === 'REG' ? languageTexts.index_text_53 : languageTexts.index_text_54}
          </div>

          <Separator />

          <div className="px-[20px] pb-[20px] min-h-[120px] max-h-[360px] overflow-y-scroll overscroll-y-contain">
            {productMasters.map((pm) => {
              const imageUrl = pm.images.length > 0 ? pm.images[0].thumbnailSmUrl : null;
              return (
                <div key={pm.id} className="mt-[20px] flex flex-col border">
                  <div className="py-[10px] flex gap-[10px]">
                    {imageUrl != null && (
                      <div className="flex-shrink-0 pl-[10px]">
                        <img src={imageUrl} className="w-[40px] h-[40px] object-cover" />
                      </div>
                    )}
                    <div className="pr-[10px] text-start">{pm.name}</div>
                  </div>
                  <Separator />
                  <div className="p-[10px] flex flex-col gap-[10px]">
                    {pm.products
                      .filter((product) => {
                        if (mode === 'REG' && product.statusFl === PRODUCT.STATUS_FL_CD.REG) {
                          return true;
                        } else if (mode === 'RENT_ING' && product.statusFl === PRODUCT.STATUS_FL_CD.RENT_ING) {
                          return true;
                        }
                        return false;
                      })
                      .map((product, index) => {
                        const isSelected = selectedProducts.some((selectedProduct) => {
                          return selectedProduct.productMasterId === pm.id && selectedProduct.id === product.id;
                        });
                        const productNameParts = [];
                        if (product.colorName != null && product.colorName.trim().length > 0) {
                          productNameParts.push(product.colorName);
                        }
                        if (product.sizeName != null && product.sizeName.trim().length > 0) {
                          productNameParts.push(product.sizeName);
                        }
                        if (product.qty != null) {
                          productNameParts.push(product.qty);
                        }

                        return (
                          <Checkbox
                            key={index}
                            checked={isSelected}
                            onClick={(isChecked) => {
                              let newSelectedProducts = [];
                              if (!isChecked) {
                                newSelectedProducts = selectedProducts.filter((selectedProduct) => {
                                  return selectedProduct.id !== product.id;
                                });
                              } else {
                                newSelectedProducts = [...selectedProducts, product];
                              }

                              if (mode === 'REG') {
                                setMenuSelectedRegProducts(newSelectedProducts);
                              } else if (mode === 'RENT_ING') {
                                setMenuSelectedRentIngProducts(newSelectedProducts);
                              }
                            }}
                            text={productNameParts.join(' / ')}
                          />
                        );
                      })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <Separator />

        <div className="p-[20px]">
          <Button
            className={'w-full px-[4px] py-[12px] text-center'}
            style={{ borderRadius: '0' }}
            text={mode === 'REG' ? languageTexts.index_text_51 : languageTexts.index_text_52}
            buttonColor={'BLACK'}
            borderColor={'BLACK'}
            textColor={'WHITE'}
            textClassName={'prose text-[14px]'}
            onClick={() => {
              if (mode === 'REG') {
                requestProductRegister(menuSelectedRegProducts);
              } else if (mode === 'RENT_ING') {
                requestProductsReturn(menuSelectedRentIngProducts);
              }
            }}
          />
        </div>
      </Menu>
    );
  };

  const renderProductsTable = () => {
    const isAmbassadorEnabled =
      props.brand.rentableUserTypeFl.includes(USER.TYPE.RENTAL_AMBASSADOR) &&
      props.brand.isAmbassadorServiceEnabled === 1;

    const headerHeight = (props?.preferences?.headerHeight ?? 0) + 'px';

    return (
      <div className="flex flex-col">
        {/* HEADER */}
        <div className="sticky px-5 flex flex-row bg-gray-200 z-[2]" style={{ top: headerHeight }}>
          <div className="col-selection prose text-[14px] text-black font-bold text-center basis-1/12">
            {languageTexts.selection}
          </div>
          {isAmbassadorEnabled === true && (
            <div className="col-output_type prose text-[14px] text-black font-bold text-center basis-2/12">
              {languageTexts.index_text_32}
            </div>
          )}
          <div className="col-image prose flex-shrink-0 text-[14px] text-black font-bold text-center basis-[140px]">
            {languageTexts.image}
          </div>
          <div className="col-name prose text-[14px] text-black font-bold text-center basis-4/12">
            {languageTexts.index_text_23}
          </div>
          <div className="col-colors prose text-[14px] text-black font-bold text-center basis-4/12">
            {languageTexts.color}
          </div>
          <div className="col-sizes prose text-[14px] text-black font-bold text-center basis-1/12">
            {languageTexts.size}
          </div>
          <div className="col-quantities prose text-[14px] text-black font-bold text-center basis-1/12">
            {languageTexts.amount}
          </div>
          <div className="col-product_states flex justify-center items-center text-[14px] text-black font-bold text-center basis-3/12">
            <div>{languageTexts.product + languageTexts.state}</div>
            {renderTooltipButton(
              'product-status-tooltip',
              <div className="py-[20px] flex flex-col items-start gap-[20px]">
                {[
                  { title: languageTexts.status_fl_1, description: languageTexts.status_fl_desc_1 },
                  { title: languageTexts.status_fl_2, description: languageTexts.status_fl_desc_2 },
                  { title: languageTexts.status_fl_4, description: languageTexts.status_fl_desc_4 },
                  { title: languageTexts.status_fl_5, description: languageTexts.status_fl_desc_5 },
                  { title: languageTexts.status_fl_6, description: languageTexts.status_fl_desc_6 },
                  { title: languageTexts.status_fl_7, description: languageTexts.status_fl_desc_7 },
                  { title: languageTexts.status_fl_8, description: languageTexts.status_fl_desc_8 },
                ].map((datum, idx) => (
                  <div key={idx}>
                    <div className="font-bold text-start">{`${idx + 1}. ${datum.title}`}</div>
                    <div className="font-normal">{datum.description}</div>
                  </div>
                ))}
              </div>,
            )}
          </div>
          <div className="col-rental_states prose text-[14px] text-black font-bold text-center basis-2/12">
            {languageTexts.index_text_41}
          </div>
          <div className="col-rental_counts prose text-[14px] text-black font-bold text-center basis-2/12">
            {languageTexts.index_text_24}
          </div>
          <div className="col-mod_del_actions prose text-[14px] text-black font-bold text-center basis-2/12">
            {languageTexts.index_text_25}
          </div>
          <div className="col-admin_requests prose text-[14px] text-black font-bold text-center basis-2/12">
            {languageTexts.index_text_26}
          </div>
        </div>

        <div className="h-[4px]"></div>

        {/* ROWS */}
        {fetchedProductMasters.map((master, index) => {
          const isSelectedReg = selectedRegProductMasters.filter((pm) => pm.id === master.id).length > 0;
          const isSelectedRentIng = selectedRentIngProductMasters.filter((pm) => pm.id === master.id).length > 0;

          let hasRegProducts = false;
          let hasRentIngProduct = false;
          let isVisibleEditBtn = true;
          let isVisibleDeleteBtn = true;

          for (let i = 0; i < master.products.length; i++) {
            if (master.products[i].statusFl === PRODUCT.STATUS_FL_CD.REG) {
              hasRegProducts = true;
            } else if (master.products[i].statusFl === PRODUCT.STATUS_FL_CD.RENT_ING) {
              hasRentIngProduct = true;
            }

            if (master.products[i].statusFl !== PRODUCT.STATUS_FL_CD.REG) {
              isVisibleEditBtn = false;
            }

            if (
              master.products[i].statusFl !== PRODUCT.STATUS_FL_CD.REG &&
              master.products[i].statusFl !== PRODUCT.STATUS_FL_CD.RETURNED
            ) {
              isVisibleDeleteBtn = false;
            }
          }

          return (
            <div key={index} id={`pm-${master.id}`} className="px-5 py-1 flex items-center gap-[8px]">
              <div className="col-selection basis-1/12 flex justify-center">
                {(hasRegProducts || hasRentIngProduct) && (
                  <Checkbox
                    checked={isSelectedReg || isSelectedRentIng}
                    onClick={(isChecked) => {
                      if (!isChecked) {
                        setSelectedRegProductMasters(selectedRegProductMasters.filter((pm) => pm.id !== master.id));
                        setSelectedRentIngProductMasters(
                          selectedRentIngProductMasters.filter((pm) => pm.id !== master.id),
                        );
                        return;
                      }

                      if (hasRegProducts) {
                        if (selectedRentIngProductMasters.length > 0) {
                          props.showModal({
                            hideCloseButton: true,
                            title: languageTexts.index_text_49,
                            text: languageTexts.index_text_50,
                          });
                          return;
                        }
                        setSelectedRegProductMasters([...selectedRegProductMasters, master]);
                      } else if (hasRentIngProduct) {
                        if (selectedRegProductMasters.length > 0) {
                          props.showModal({
                            hideCloseButton: true,
                            title: languageTexts.index_text_47,
                            text: languageTexts.index_text_48,
                          });
                          return;
                        }
                        setSelectedRentIngProductMasters([...selectedRentIngProductMasters, master]);
                      }
                    }}
                  />
                )}
              </div>
              {isAmbassadorEnabled === true && (
                <div className="col-output_type flex justify-center basis-2/12 text-center">
                  <OutputTypeSelector {...props} master={master} />
                </div>
              )}
              <div className="col-image flex-shrink-0 flex justify-center basis-[140px]">
                <div
                  style={{
                    width: '120px',
                    height: '120px',
                    aspectRatio: '1/1',
                    overflow: 'hidden',
                    border: '1px solid #E8E8E8',
                  }}
                >
                  <Swiper
                    pagination={{
                      dynamicBullets: true,
                    }}
                    modules={[Pagination, Navigation]}
                  >
                    {master.products.map((image: any) => {
                      return (
                        <SwiperSlide
                          className="w-full h-full justify-center"
                          key={`PostingImage${image.id}`}
                          onClick={() => {
                            props.showModal({
                              hideDimmer: false,
                              className: '',
                              renderCustomCloseButton: (closeModal) => (
                                <div
                                  className="absolute right-0 top-0 p-[30px] cursor-pointer"
                                  onClick={() => {
                                    closeModal();
                                  }}
                                >
                                  <X strokeWidth={3} color="#000" size={28} />
                                </div>
                              ),
                              content: () => {
                                return (
                                  <img
                                    src={`${image.thumbnailUrl}`}
                                    className="object-contain w-auto h-auto"
                                    style={{
                                      maxWidth: '90svw',
                                      maxHeight: '90svh',
                                    }}
                                  />
                                );
                              },
                            });
                          }}
                        >
                          <img className="w-full h-full object-cover" src={image.thumbnailSmUrl} />
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
              </div>

              <div className="col-name basis-4/12">
                <div>{`${master.name}`}</div>
                {master?.subItem && <div className="text-[12px] text-gray-400">{`${master.subItem}`}</div>}
              </div>

              {master.products.length ? (
                <>
                  <div className="col-colors basis-4/12 text-center flex flex-col gap-2">
                    {master.products.map((product, i) => {
                      return (
                        <div key={i} className="px-1">
                          <div className="ml-auto" style={{}}>
                            <Button
                              style={{
                                padding: 0,
                                height: '24px',
                                maxWidth: '150px',
                              }}
                              textStyle={{
                                padding: 0,
                                margin: 0,
                                textShadow: '1px 1px 0px rgba(0,0,0,0.9)',
                              }}
                              textClassName={'prose text-sm whitespace-nowrap overflow-hidden text-ellipsis px-1'}
                              textColor={'WHITE'}
                              text={`${product.colorName}`}
                              description={`${product.colorName}`}
                              buttonColor={`#${product.colorValue}`}
                              onClick={() => {
                                props.showModal({
                                  hideDimmer: false,
                                  className: '',
                                  renderCustomCloseButton: (closeModal) => (
                                    <div
                                      className="absolute right-0 top-0 p-[30px] cursor-pointer"
                                      onClick={() => {
                                        closeModal();
                                      }}
                                    >
                                      <X strokeWidth={3} color="#000" size={28} />
                                    </div>
                                  ),
                                  content: () => {
                                    return (
                                      <img
                                        src={`${product.thumbnailUrl}`}
                                        className="object-contain w-auto h-auto"
                                        style={{
                                          maxWidth: '90svw',
                                          maxHeight: '90svh',
                                        }}
                                      />
                                    );
                                  },
                                });
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="col-sizes basis-1/12 text-center flex flex-col gap-2">
                    {master.products.map((product, i) => {
                      return <span key={i}>{product.qty == 0 ? languageTexts.index_text_27 : product.sizeName}</span>;
                    })}
                  </div>
                  <div className="col-quantities basis-1/12 text-center flex flex-col gap-2">
                    {master.products.map((product, i) => {
                      return <span key={i}>{product.qty == 0 ? languageTexts.index_text_27 : product.qty}</span>;
                    })}
                  </div>
                  <div className="col-product_states basis-3/12 text-center flex flex-col gap-2">
                    {master.products.map((product, i) => {
                      return (
                        <span key={i}>
                          {product.qty == 0 ? languageTexts.index_text_27 : productStatusFl_title_map[product.statusFl]}
                        </span>
                      );
                    })}
                  </div>
                  <div className="col-rental_states basis-2/12 flex flex-col items-center text-center gap-2">
                    {master.products.map((product, i) => {
                      if (
                        product.statusFl === PRODUCT.STATUS_FL_CD.REG ||
                        product.qty == null ||
                        product.qtyRentable == null
                      ) {
                        console.warn('[ERROR] no qty or qtyRentable. product_id: ', product.id);
                        return <span key={i}>{'-'}</span>;
                      }

                      const isRented = product.qty - product.qtyRentable;

                      return (
                        <span key={i}>
                          {product.statusFl >= 2 && product.statusFl <= 6 ? (
                            <div
                              className={`flex flex-row ${isRented ? 'cursor-pointer' : ''}`}
                              onClick={() => {
                                if (isRented) showCurrentlyInRentUserModal(product.id, product.currentlyInRental);
                              }}
                              onTouchStart={() => {
                                if (isRented && props.preferences.isMobile) {
                                  showCurrentlyInRentUserModal(product.id, product.currentlyInRental);
                                }
                              }}
                            >
                              <span className={`${isRented ? 'text-[#000000]' : ''}`}>
                                {languageTexts._index_text_42(product.qty - product.qtyRentable)}
                              </span>
                            </div>
                          ) : (
                            '-'
                          )}
                        </span>
                      );
                    })}
                  </div>
                  <div className="col-rental_counts basis-2/12 text-center flex flex-col gap-2">
                    {master.products.map((product, i) => {
                      if (product.statusFl === PRODUCT.STATUS_FL_CD.REG) {
                        return <span key={i}>{'-'}</span>;
                      }
                      return <span key={i}>{languageTexts._times(product.favoriteCnt)}</span>;
                    })}
                  </div>
                  <div className="col-mod_del_actions flex flex-col gap-1 justify-center prose text-black text-center items-center basis-2/12">
                    <div className="flex flex-row justify-center gap-1">
                      {!isVisibleEditBtn && !isVisibleDeleteBtn && <span>{'-'}</span>}
                      {isVisibleEditBtn && (
                        <Button
                          className={'py-1 px-1 md:px-3'}
                          style={{ borderRadius: '0' }}
                          text={languageTexts.modify}
                          buttonColor={'#FFF'}
                          borderColor={'#E8E8E8'}
                          textColor={'BLACK'}
                          textClassName={'prose text-sm'}
                          onClick={() => {
                            showProductMasterDetailModal('EDIT', master);
                          }}
                        />
                      )}
                      {isVisibleDeleteBtn && (
                        <Button
                          className={'py-1 px-1 md:px-3'}
                          style={{ borderRadius: '0' }}
                          text={languageTexts.delete}
                          buttonColor={'#FFF'}
                          borderColor={'#E8E8E8'}
                          textColor={'#999'}
                          textClassName={'prose text-sm'}
                          onClick={() => {
                            Swal.fire({
                              icon: 'info',
                              text: languageTexts.index_text_28,
                              showCancelButton: true,
                              confirmButtonText: languageTexts.delete,
                              cancelButtonText: languageTexts.cancel,
                            }).then((result) => {
                              if (result.isConfirmed) {
                                API.Product.delete({
                                  id: master.id,
                                  brandToken: props.auth.token,
                                })
                                  .then((response) => {
                                    props.showModal({
                                      text: languageTexts._index_text_29(master.name),
                                    });
                                  })
                                  .catch((error) => {
                                    props.showModal({
                                      text: error.message,
                                    });
                                  })
                                  .finally(() => {
                                    fetchProductMasters({ refresh: true });
                                  });
                              }
                            });
                          }}
                        />
                      )}
                    </div>
                  </div>
                  {renderProductContextTab(master, hasRegProducts, hasRentIngProduct)}
                </>
              ) : (
                <>
                  <div className="text-center flex flex-row justify-center w-full">
                    <div
                      className="flex flex-row gap-1 items-center cursor-pointer"
                      onClick={() => {
                        showProductMasterDetailModal('EDIT', master);
                      }}
                    >
                      <HelpCircle />
                      <span>{languageTexts.index_text_30}</span>
                    </div>
                  </div>
                  {renderProductContextTab(master, hasRegProducts, hasRentIngProduct)}
                </>
              )}
            </div>
          );
        })}

        {/* {renderLoadingIndicator()} */}

        {paginator ? (
          <Paginator
            currentPage={currentPage}
            lastPage={paginator.lastPage}
            onPageChange={(page) => {
              fetchProductMasters({ page: page });
            }}
          />
        ) : null}
      </div>
    );
  };

  const renderBottomButtons = () => {
    return (
      <div className="px-5 py-6 fixed bottom-0 left-1/2 transform -translate-x-1/2 z-[1]">
        {selectedRegProductMasters.length > 0 ? (
          <Button
            textColor={'#FFF'}
            className="px-3 py-[24px] w-[240px] flex items-center justify-center rounded-[3px] font-bold"
            buttonColor={'#000000'}
            borderColor={'#000000'}
            text={languageTexts._index_text_64(selectedRegProductMasters.length, regProductCnt)}
            onClick={(e) => {
              handleAdminRequestBulkButtonClick(e);
            }}
          />
        ) : selectedRentIngProductMasters.length > 0 ? (
          <Button
            textColor={'#000'}
            className="px-3 py-[24px] w-[240px] flex items-center justify-center rounded-[3px] font-bold"
            buttonColor={'#FFF'}
            borderColor={'#000'}
            text={languageTexts._index_text_65(selectedRentIngProductMasters.length, rentIngProductCnt)}
            onClick={(e) => {
              handleAdminRequestBulkButtonClick(e);
            }}
          />
        ) : null}
      </div>
    );
  };

  const TermsModal = (props: any) => {
    return (
      <Modal
        className="squared-antd-modal"
        centered={true}
        open={props.isTermsModalVisible}
        footer={null}
        closable={false}
        zIndex={1080}
        width={400}
      >
        <div className="flex flex-col justify-center align-center p-8 bg-white">
          <div className="content flex flex-col">
            <div className="font-bold text-[22px] text-black">{languageTexts.index_text_33}</div>
            <div className="flex flex-col items-start py-4">
              <span className="prose prose-md whitespace-pre-wrap leading-5 text-black">
                {languageTexts.index_text_34}
              </span>
            </div>

            <div>
              <Button
                className={'w-full py-3 flex justify-center text-center text-base'}
                textColor={'WHITE'}
                buttonColor={'BLACK'}
                text={languageTexts.agreement}
                onClick={() => {
                  props.setIsTermsModalVisible(false);
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <>
      {!isFetching ? null : (
        <div className="fixed top-0 w-full h-full flex items-center justify-center bg-slate-400 opacity-50 z-[3]">
          <LoadingText
            text={'Loading'}
            render={(text) => (
              <div className="w-[180px] rounded-full p-2 text-center text-2xl font-bold text-white select-none">
                {text}
              </div>
            )}
          />
        </div>
      )}

      <div className="header-container">
        {renderProductsHeaderStatus()}
        {renderProductsHeaderInput()}
      </div>
      <div className="body-container mt-[14px] text-[14px]">{renderProductsTable()}</div>
      <div className="h-[400px]">
        {renderBottomButtons()}
        {renderRequestMenu()}
      </div>
      <TermsModal isTermsModalVisible={isTermsModalVisible} setIsTermsModalVisible={setIsTermsModalVisible} />
      {isGlovv() == false ? (
        <SeedingWithCommissionsPanel
          isPanelVisible={false}
          hideBlockButton={true}
          type={SEEDING_WITH_COMMISSION_TYPE.REELS}
          showAlert={isCommissionsPanelVisible}
        />
      ) : null}
      <CurrentlyInRentUserModal
        isCurrentlyInRentUserModalVisible={currentlyInRentModalVisible}
        setIsCurrentlyInRentUserModalVisible={setCurrentlyInRentModalVisible}
        currentlyInRentUsers={currentlyInRentUsers}
        setCurrentlyInRentUsers={setCurrentlyInRentUsers}
        brand={props.brand}
      />
    </>
  );
};

const OutputTypeSelector = (props) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.products };

  const navigate = useNavigate();
  const options = [
    { name: languageTexts.index_text_43, value: 1 },
    { name: languageTexts.reels, value: 2 },
  ];
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (props?.master?.outputType == null) return;

    const propsOption = options.find((o) => o.value === props.master.outputType);
    if (propsOption != null) setSelectedOption(propsOption);
  }, []);

  const updateOutputType = useCallback(
    async (newSelectedOption) => {
      try {
        await API.Product.updateMaster({
          brandToken: props.auth.token,
          id: props.master.id,
          outputType: newSelectedOption.value,
        });
        setSelectedOption(newSelectedOption);
        setTimeout(() => {
          props.showModal({
            hideCloseButton: true,
            isCompact: true,
            text: languageTexts.index_text_35,
          });
        }, 400);
      } catch (e) {
        if (e.message === 'The brand has no ambassador reels rule') {
          setTimeout(() => {
            props.showModal({
              title: e.message,
              text: languageTexts.index_text_36,
              confirmButtonText: languageTexts.index_text_37,
              confirm: (params) => {
                navigate(ROUTES.RENTAL_AMBASSADOR_REQUIREMENTS_VIDEO.PATH);
              },
            });
          }, 400);
          return;
        }
        // other errors
        setTimeout(() => {
          props.showModal({
            hideCloseButton: true,
            isCompact: true,
            text: e.message,
          });
        }, 400);
      }
    },
    [props.auth.token, props.master.id],
  );

  const showUpdateWarningModal = useCallback(
    (callback, beforeOption, nextOption) => {
      const nextTargetName = nextOption;
      const beforeTargetName = beforeOption;

      props.showModal({
        title: languageTexts._index_text_38(nextTargetName),
        text: languageTexts._index_text_39({ beforeTargetName, nextTargetName }),
        confirmText: languageTexts.index_text_40,
        confirm: () => {
          callback ? callback() : null;
        },
        cancel: () => {},
      });
    },
    [props.auth.token, props.master.id],
  );

  if (selectedOption == null) return <div></div>;

  return (
    <div>
      <Select
        className={'w-full h-full flex flex-row border-black text-center tracking-tight'}
        innerClassName={'py-2 px-2'}
        innerStyle={{
          paddingLeft: '10px',
          paddingRight: '10px',
        }}
        selectClassName={'pr-1'}
        bordered
        margin={0}
        options={options}
        value={selectedOption.name}
        selected={selectedOption}
        onChange={(value) => {
          const selected = options.filter((option) => option.name == value)[0];

          const callback = () => {
            updateOutputType(selected);
          };

          if (selectedOption.name != value && props.brand.postingNotFinishedCountTypeRental) {
            showUpdateWarningModal(callback, selectedOption.name, value);
            return false;
          }

          callback();
        }}
      />
    </div>
  );
};

const ProgressModal = (props) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.invite };
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (props.isProgressModalVisible == false) {
      setProgress(0);
    }

    if (props.isProgressModalVisible) {
      const targetProgress = 100;
      const duration = 2000;

      const startTime = Date.now();

      const increaseProgress = () => {
        const currentTime = Date.now();
        const elapsedTime = currentTime - startTime;

        if (progress < targetProgress && elapsedTime < duration) {
          setProgress(Math.min(targetProgress, (elapsedTime / duration) * targetProgress));
          requestAnimationFrame(increaseProgress);
        } else {
          setProgress(100);
          props.onComplete ? props.onComplete() : null;
        }
      };

      increaseProgress();
    }
  }, [props.isProgressModalVisible]);

  return (
    <Modal
      centered={true}
      open={props.isProgressModalVisible}
      onOk={props.handleOk}
      footer={null}
      closable={false}
      zIndex={1082}
    >
      <div className="text-center text-black text-[17px] font-normal py-[15px]">{languageTexts.intro_text_23}</div>

      <div className="text-center text-black text-lg font-bold">{progress.toFixed(1)}%</div>

      <div className="w-[275px] h-[6px] bg-gray-200 rounded-[32px] relative my-[10px] mx-auto">
        <div
          className="absolute inset-0 h-full bg-orange-500 rounded-[32px]"
          style={{
            width: `${progress.toFixed(1)}%`,
          }}
        />
      </div>
    </Modal>
  );
};

const CompleteModal = (props) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.invite };
  useEffect(() => {
    if (props.isCompleteModalVisible) {
      setTimeout(() => {
        props.onComplete ? props.onComplete() : null;
      }, 1000);
    }
  }, [props.isCompleteModalVisible]);

  return (
    <Modal centered={true} open={props.isCompleteModalVisible} footer={null} closable={false} zIndex={1082}>
      <div className="flex flex-col gap-[16px]">
        <div className="text-center text-black text-[17px] font-normal py-[15px]">{languageTexts.intro_text_24}</div>

        <div className="mx-auto flex justify-center items-center">
          <img src={`/assets/icons/check-orange.svg`} />
        </div>
      </div>
    </Modal>
  );
};

const ManagerModal = (props) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.invite };
  return (
    <Modal centered={true} open={props.isManagerModalVisible} footer={null} closable={false} zIndex={1082}>
      <div className="flex flex-col gap-[30px] py-[50px]">
        <div className="flex flex-col justify-center mx-auto items-center gap-[10px]">
          <img src={`${props.avatar}`}></img>
          <div className="text-black text-[17px] font-bold">{languageTexts.intro_text_25}</div>
          {/* <img className="max-w-[58px]" src={`/assets/logo/logo-black-sm.svg`}></img> */}
        </div>
        <div className="text-center text-black text-[17px] font-normal py-[15px]">
          {languageTexts._intro_text_26(props.name)}
        </div>
      </div>

      <div className="w-full flex flex-col pb-[50px]">
        <div
          className="flex justify-center items-center w-[140px] h-12 bg-orange-500 rounded-[41px] mx-auto cursor-pointer"
          onClick={props.onOk ? props.onOk : null}
        >
          <div className="text-center text-white text-[17px] font-bold">{languageTexts.confirm}</div>
        </div>
      </div>
    </Modal>
  );
};

const CurrentlyInRentUserModal = (props) => {
  return (
    <Modal
      className="squared-antd-modal rounded-[20px] shadow-md bg-white overflow-hidden"
      centered={true}
      open={props.isCurrentlyInRentUserModalVisible}
      onOk={props.handleOk}
      footer={null}
      closable={true}
      zIndex={1082}
      onClose={() => {
        props.setIsCurrentlyInRentUserModalVisible(false);
        props.setCurrentlyInRentUsers([]);
      }}
      onCancel={() => {
        props.setIsCurrentlyInRentUserModalVisible(false);
        props.setCurrentlyInRentUsers([]);
      }}
    >
      {props?.currentlyInRentUsers && props?.currentlyInRentUsers.length ? (
        <div className="flex flex-col gap-[20px] p-[50px]">
          <p className="text-[22px] font-bold">대여 중인 모델 목록</p>

          <div className="flex flex-col gap-[10px]">
            {props?.currentlyInRentUsers?.map((rental, i) => {
              return (
                <div key={i} className="flex flex-row gap-[10px] items-center">
                  <img
                    key={i}
                    className={`rounded-full w-[48px] h-[48px] border-2 border-white`}
                    src={rental.user.profileImageUrl}
                  />

                  <span className="text-[15px] mr-[10px]">{rental.user.username}</span>

                  <span
                    className="text-[15px] mr-[10px] text-[#000000] underline cursor-pointer"
                    onClick={() => {
                      window.open(
                        `https://www.instagram.com/${rental.user.userModel.instaUserId}${
                          props?.brand?.isCategoryBeauty ? 'reels/' : ''
                        }`,
                        '_blank',
                      );
                    }}
                  >
                    {rental.user.userModel.instaUserId}
                  </span>
                </div>
              );
            })}
          </div>

          <Button
            buttonColor={'black'}
            justify={'center'}
            textColor={'white'}
            className="mt-[25px] py-[15px]"
            textClassName={'flex flex-row justify-center text-[15px] font-bold'}
            text="확인"
            onClick={() => {
              props.setIsCurrentlyInRentUserModalVisible(false);
              props.setCurrentlyInRentUsers([]);
            }}
          />
        </div>
      ) : (
        <div className="flex flex-col gap-[20px] p-[50px]">
          <p className="text-[22px] font-bold">대여 중인 모델 목록</p>
          <p className="text-[15px]">이 제품을 대여 중인 모델이 없습니다.</p>

          <Button
            buttonColor={'black'}
            justify={'center'}
            textColor={'white'}
            className="flex flex-row justify-center mt-[25px] py-[15px]"
            textClassName={'text-[15px] font-bold'}
            text="확인"
            onClick={() => {
              props.setIsCurrentlyInRentUserModalVisible(false);
              props.setCurrentlyInRentUsers([]);
            }}
          />
        </div>
      )}
    </Modal>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(ProductsIndex);
